import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { isEmpty } from 'remeda';

interface UseTabs<T> {
  activeTab: T;
  onTabChange: (tab: T) => void;
}

export function useTabs<T extends string>(defaultTab: T, key: string = 'tab'): UseTabs<T> {
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeTab, setActiveTab] = useState<T>((searchParams.get(key) as T) || defaultTab);

  const onTabChange = useCallback(
    (tab: T) => {
      setSearchParams((prev) => {
        if (isEmpty(tab)) {
          prev.delete(key);
        } else {
          prev.set(key, tab);
        }

        return prev;
      });

      setActiveTab(tab);
    },
    [key, setSearchParams]
  );

  return { activeTab, onTabChange };
}
